import React from 'react';
import { BarChart3, LineChart, PieChart as PieChartIcon } from 'lucide-react';

const AnalyticsPage = () => {
  const analytics = [
    { metric: 'Page Views', value: '15,234', change: '+5.2%', icon: BarChart3 },
    { metric: 'Unique Visitors', value: '8,543', change: '+12.3%', icon: LineChart },
    { metric: 'Bounce Rate', value: '32.5%', change: '-2.1%', icon: PieChartIcon },
    { metric: 'Avg. Session', value: '4m 32s', change: '+1.5%', icon: BarChart3 },
  ];

  return (
    <>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Analytics & Insights</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        {analytics.map((item, index) => {
          const Icon = item.icon;
          return (
            <div key={index} className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-600 text-sm font-medium mb-1">{item.metric}</p>
                  <h3 className="text-2xl font-bold text-gray-900">{item.value}</h3>
                  <p className="text-primary-600 text-sm font-semibold mt-2">{item.change}</p>
                </div>
                <div className="bg-primary-50 text-primary-500 p-4 rounded-lg">
                  <Icon size={24} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Traffic Source</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Direct</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-primary-500 h-2 rounded-full" style={{width: '45%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">45%</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Organic</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-accent-500 h-2 rounded-full" style={{width: '35%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">35%</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Referral</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-primary-500 h-2 rounded-full" style={{width: '20%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">20%</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Device Usage</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Desktop</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-blue-500 h-2 rounded-full" style={{width: '55%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">55%</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Mobile</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-purple-500 h-2 rounded-full" style={{width: '40%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">40%</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-600">Tablet</span>
              <div className="w-32 bg-gray-200 rounded-full h-2">
                <div className="bg-orange-500 h-2 rounded-full" style={{width: '5%'}}></div>
              </div>
              <span className="font-semibold text-gray-900">5%</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalyticsPage;
